import React from 'react';
import { Formik, Field } from 'formik';

import styles from './userSavedSearchesPageStyles';

import AlertName from './alertName';
import SingleCheckboxField from 'buyside/components/presentation/Form/Field/SingleCheckboxField/singleCheckboxField';
import SavedSearchCriteriaFormatter from 'buyside/components/presentation/UserAccount/SavedSearches/savedSearchCriteriaFormatter';

import { noop } from 'buyside/util/lodashAlt';

import PencilIcon from 'buyside/svgs/pencil.svg';
import TrashIcon from 'buyside/svgs/trash.svg';

class SavedSearchAlertItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editOpen: {} };

    this.closeEditBox = this.closeEditBox.bind(this);
    this.handleEditNameClick = this.handleEditNameClick.bind(this);
    this.handleUpdateSearchAlert = this.handleUpdateSearchAlert.bind(this);
  }

  closeEditBox(alert) {
    const editOpen = { ...this.state.editOpen };
    delete editOpen[`${alert.id}`];
    return this.setState({ editOpen });
  }

  handleEditNameClick(alert) {
    const editOpen = { ...this.state.editOpen, [alert.id]: alert.name };
    return this.setState({ editOpen });
  }

  handleUpdateSearchAlert(values, alert) {
    this.props.updateSearchAlert(values).then(() => this.closeEditBox(alert));
  }

  render() {
    const {
      alert,
      initialValues,
      alertNameValues,
      criteriaObj,
      updateSearchAlert,
      handleDeleteSearchAlert,
      label
    } = this.props;

    const editOpenIds = Object.keys(this.state.editOpen);

    return (
      <div className={styles.searchItem} data-testid={alert.id}>
        <div className={styles.mutationArea}>
          <AlertName
            alert={alert}
            closeEditBox={() => this.closeEditBox(alert)}
            editOpenIds={editOpenIds}
            initialValues={alertNameValues}
            handleUpdateSearchAlert={this.handleUpdateSearchAlert}
          />
          <div className={styles.editDeleteButtons}>
            <div data-test="editButton" onClick={() => this.handleEditNameClick(alert)}>
              {!editOpenIds.includes(alert.id) ? (
                <div>
                  <PencilIcon className={styles.icon} />
                  <span>Edit Name</span>
                </div>
              ) : null}
            </div>
            <div data-test="deleteButton" onClick={() => handleDeleteSearchAlert(alert)}>
              <TrashIcon className={styles.icon} />
              <span>Delete</span>
            </div>
          </div>
        </div>
        <div>
          <SavedSearchCriteriaFormatter criteriaObj={criteriaObj} />
        </div>
        <Formik initialValues={initialValues} onSubmit={noop}>
          {({ values }) => (
            <div>
              <Field
                component={SingleCheckboxField}
                customStyles={styles}
                label="Show this saved search on filter pages"
                name="display"
                onClick={() => updateSearchAlert({ ...values, display: !values.display })}
                overrideStyles={styles}
                value={values.display || false}
              />
              <Field
                component={SingleCheckboxField}
                customStyles={styles}
                label={label}
                name="active"
                onClick={() => updateSearchAlert({ ...values, active: !values.active })}
                overrideStyles={styles}
                value={values.active}
              />
            </div>
          )}
        </Formik>
      </div>
    );
  }
}

export default SavedSearchAlertItem;
